import React, { useState } from "react";
import { Mail, Check } from "lucide-react";
import { FaYoutube, FaInstagram, FaFacebookF, FaTiktok } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { scareCTA, socials } from "../mock";
import Reveal from "./Reveal";

const iconMap = {
  YouTube: FaYoutube,
  Instagram: FaInstagram,
  Facebook: FaFacebookF,
  X: FaXTwitter,
  TikTok: FaTiktok,
};
const brandColor = {
  YouTube: "#FF0000",
  Instagram: "#E4405F",
  Facebook: "#1877F2",
  X: "#000000",
  TikTok: "#010101",
};

const ScareCTA = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || "Something went wrong. Please try again.");
        return;
      }
      setSent(true);
      setEmail("");
      setTimeout(() => setSent(false), 4000);
    } catch (err) {
      setError("Network error. Please try again.");
    }
  };

  return (
    <section id="watch" className="py-16 md:py-24 relative overflow-hidden" style={{ background: "linear-gradient(135deg, #FF6C10 0%, #ff8636 100%)" }}>
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <div>
              <h2 className="font-display text-white text-3xl md:text-5xl brave-shadow-text">{scareCTA.title}</h2>
              <p className="mt-5 text-white/95 text-base md:text-lg leading-relaxed font-semibold">{scareCTA.body}</p>

              {/* Email signup */}
              <form onSubmit={submit} className="mt-7 flex flex-col sm:flex-row gap-3 max-w-md">
                <div className="flex items-center gap-2 bg-white rounded-full px-4 flex-1 shadow-md">
                  <Mail className="w-5 h-5" style={{ color: "#FF6C10" }} />
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email" data-testid="subscribe-email-input" className="flex-1 py-3 bg-transparent outline-none text-slate-700 font-semibold" />
                </div>
                <button type="submit" data-testid="subscribe-submit-button" className="inline-flex items-center justify-center gap-2 font-display text-white px-6 py-3 rounded-full shadow-lg transition-transform hover:scale-105" style={{ backgroundColor: "#187EE4" }}>
                  {sent ? (<><Check className="w-5 h-5" /> Subscribed!</>) : "Follow Brave Me HQ"}
                </button>
              </form>
              {error && <p className="mt-2 text-white text-sm font-semibold" data-testid="subscribe-error">{error}</p>}

              {/* Social links */}
              <div className="mt-8">
                <p className="font-display text-white text-lg mb-3">Follow us on @BraveMeRoars</p>
                <div className="flex flex-wrap gap-3">
                  {socials.map((s) => {
                    const Icon = iconMap[s.name];
                    const disabled = s.href === "#";
                    return (
                      <a
                        key={s.name}
                        href={s.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={s.name}
                        title={s.name + (disabled ? " (soon)" : "")}
                        data-testid={`social-${s.name.toLowerCase()}`}
                        className={`inline-flex items-center justify-center w-11 h-11 rounded-full bg-white shadow-md transition-transform hover:scale-110 hover:-translate-y-0.5 ${disabled ? "opacity-60" : ""}`}
                        style={{ color: brandColor[s.name] }}
                      >
                        {Icon && <Icon className="w-5 h-5" />}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={130}>
            <div className="grid grid-cols-2 gap-4">
              {scareCTA.images.map((img, i) => (
                <img key={i} src={img} alt="Happy children" className={`rounded-3xl shadow-xl w-full h-full object-cover aspect-[4/5] ${i === 1 ? "mt-8" : ""}`} />
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ScareCTA;
